import { tint } from "../../utils/colors";
import { systemFontStack } from "../utils/AdaptiveUiThemeStyle";
/**
 * Kystverket client theme
 */
export const kv = {
    name: "kv",
    fontStack: `"Museo Sans", ${systemFontStack}`,
    fontWeight: 400,
    headingFontWeight: 400,
    labelTextColor: "#1d3c34",
    headingTextColor: "#1d3c34",
    primary: "#000667",
    primaryContrast: "#fafafa",
    secondary: "#a9e5fb",
    secondaryContrast: "#000667",
    tertiary: "#ff451f",
    tertiaryContrast: "#fafafa",
    success: "#3ba460",
    successContrast: "#ffffff",
    warning: "#ffc358",
    danger: "#ff451f",
    dangerContrast: "#fafafa",
    dark: "#202123",
    medium: "hsl(30, 33%, 87%)",
    light: {
        darker: "#000667",
        dark: "#a9e5fb",
        shade: tint("#a9e5fb", 10),
        default: "#f9f6f3",
        tint: "#f9f9f9",
        light: "#fafafa",
        lighter: "#fff",
    },
    buttonStyle: "outline",
    buttonBorderWidth: 2,
    buttonPadding: "10px 20px",
    smallButtonPadding: "5px 10px",
    largeButtonPadding: "15px 30px",
    inputBackground: "#f9f9f9",
    inputShadowBlur: 0,
    inputShadowOffset: "0 0",
};
